module.exports = __webpack_public_path__ + "static/media/eclipse-explained.e15fc955.png";